import { ModalHeader } from 'components/layout/ModalHeader';
import { InfoModal } from 'components/widgets/InfoModal';
import LandTitleSection from 'components/widgets/LandTitleSection';

import { useLandTitleChangeV4 } from 'hooks/useDocuments';
import { useLandTitleChange } from 'hooks/useLandTitleChange';
import { useGetModalActions, useGetQueryParam } from 'hooks/useModal';

const LandTitleChangeModal = ({
  enableFetchByDocumentId = false,
}: {
  enableFetchByDocumentId?: boolean;
}) => {
  let result: any;

  if (enableFetchByDocumentId) {
    const documentId = useGetQueryParam('documentId');
    result = useLandTitleChangeV4(documentId || undefined);
  } else {
    const documentUuid = useGetQueryParam('landTitleChange');
    result = useLandTitleChange(documentUuid);
  }

  const { Skeleton, ...modalProps } = useGetModalActions(result.isLoading);

  return (
    <InfoModal
      {...modalProps}
      header={
        <ModalHeader Skeleton={Skeleton} type="Land Title Change">
          {result.data?.document_number}
        </ModalHeader>
      }
    >
      <LandTitleSection
        result={result.data}
        skeleton={Skeleton}
        isLoading={result.isLoading}
      />
    </InfoModal>
  );
};

export default LandTitleChangeModal;
